import { ModuleFE_RoutingV2, ModuleFE_XHR, StorageKey, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, currentTimeMillis, exists, JwtTools, Module, resolveContent } from '@nu-art/ts-common';
import { HeaderKey_Authorization, ResponseHeaderKey_JWTToken } from '@nu-art/thunderstorm-shared';
import { QueryParam_SessionId } from '@nu-art/user-account-shared';
export const dispatch_onSessionUpdated = new ThunderDispatcher('__onSessionUpdated');
export const StorageKey_SessionTimeoutTimestamp = new StorageKey(`storage-accounts__session-timeout`);
export class SessionKey_FE {
    key;
    constructor(key) {
        this.key = key;
    }
    get(defaultValue) {
        // @ts-ignore
        const sessionData = ModuleFE_Session.sessionData;
        // means that we don't have a session yet
        if (!sessionData)
            return;
        if (!(this.key in sessionData) && !exists(defaultValue))
            throw new BadImplementationException(`Couldn't find key "${this.key}" in session data`);
        return sessionData[this.key] ?? defaultValue;
    }
}
export const sessionContentJWT = async (sessionAsString) => {
    return JwtTools.decode(sessionAsString);
};
class ModuleFE_Session_Class extends Module {
    // @ts-ignore
    sessionData;
    sessionDecoder = sessionContentJWT;
    sessionKey = 'session-jwt';
    StorageKey_SessionId;
    init() {
        this.StorageKey_SessionId = new StorageKey(resolveContent(this.sessionKey));
        this.StorageKey_SessionId.onChange(async (sessionAsString) => {
            await this.onSessionUpdated(sessionAsString);
        });
        ModuleFE_XHR.addDefaultHeader(HeaderKey_Authorization, () => {
            const sessionJWT = this.StorageKey_SessionId.get();
            if (!sessionJWT)
                return '';
            return `Bearer ${sessionJWT}`;
        });
        ModuleFE_XHR.setDefaultOnComplete(async (__, _, request) => {
            if (!request.getUrl().startsWith(ModuleFE_XHR.getOrigin()))
                return;
            const responseHeader = request.getResponseHeader(ResponseHeaderKey_JWTToken);
            if (!responseHeader)
                return;
            const sessionId = typeof responseHeader === 'string' ? responseHeader : responseHeader[0];
            this.StorageKey_SessionId.set(sessionId);
        });
        const prevSessionId = this.StorageKey_SessionId.get();
        let sessionId = ModuleFE_RoutingV2.getQueryParameter(QueryParam_SessionId);
        if (sessionId) {
            if (!this.config.keepJwtAfterInit)
                setTimeout(() => ModuleFE_RoutingV2.removeQueryParam(QueryParam_SessionId), 5000);
            this.StorageKey_SessionId.set(sessionId);
            if (sessionId === prevSessionId)
                this.onSessionUpdated(sessionId)
                    .then(() => console.log('on session updated'))
                    .catch(err => console.error('Error on session updated', err));
            return;
        }
        if (!prevSessionId)
            return;
        this.isSessionValid().then((sessionValid) => {
            if (!sessionValid)
                return this.StorageKey_SessionId.delete();
            this.onSessionUpdated(prevSessionId)
                .then(() => console.log('on session updated'))
                .catch(err => console.error('Error on session updated', err));
        });
    }
    setSessionKey(sessionKey) {
        this.sessionKey = sessionKey;
    }
    async __onStorageKeyEvent(event) {
        if (event.key !== this.StorageKey_SessionId.key)
            return;
        await this.onSessionUpdated(this.StorageKey_SessionId.get());
    }
    __onAuthRequiredListener(request) {
        this.StorageKey_SessionId.delete();
        StorageKey_SessionTimeoutTimestamp.set(currentTimeMillis());
    }
    async onSessionUpdated(sessionAsString) {
        if (sessionAsString)
            try {
                this.sessionData = await this.sessionDecoder(sessionAsString);
            }
            catch (e) {
                this.logError('Error decoding session data', e);
            }
        else
            this.sessionData = {};
        dispatch_onSessionUpdated.dispatchAll();
    }
    hasSession() {
        return !!this.StorageKey_SessionId.get();
    }
    async isSessionValid() {
        const sessionToken = this.StorageKey_SessionId.get();
        if (!sessionToken)
            return false;
        return JwtTools.isJwtActive(sessionToken);
    }
    getJWT = () => this.StorageKey_SessionId.get();
}
export const ModuleFE_Session = new ModuleFE_Session_Class();
//# sourceMappingURL=ModuleFE_Session.js.map